<template>
    <div v-if="is_home_page" style="margin-bottom: 6.5rem;">
        <Header v-if="show_component" ref="index" />

        <div id="vueloader">
            <div class="text-center">
                <br />
                <br />
                <br />
                <br />
                <br />
                <p class="text-muted">
                    <font-awesome-icon icon="fas fa-circle-notch" size="5x" spin />
                </p>
                <br />
                <div class="text-muted">
                    <div id="vueloader-wait">
                        <p>Please do not close or refresh this page</p>
                    </div>
                    <div id="vueloader-reload" style="display: none">
                        <p>
                            This is taking too long to load.
                            <br />
                            Please check if your network connection is online,
                            and try again.
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <br />

        <component :is="currentView" />

        <Footer v-if="show_component" />
    </div>

    <div v-if="!is_home_page" class="d-flex flex-column align-items-center" style="margin-bottom: 6.5rem;">
        <br><br>
        <img class="cs-404page-icon" src="https://cdn.cec.fimt.payandgo.link/uploads/payngo_logo.png">
        <h1 class="fw-bold cs-404page-title">404</h1>
        <h1>Page not found</h1>
    </div>
</template>

<script>
import * as bootstrap from 'bootstrap';

import Voucher from "./pages/Voucher.vue";
import VoucherDetail from "./pages/VoucherDetail.vue";
import MyVoucher from "./pages/MyVoucher.vue";

import PaymentStatus from "./components/PaymentStatus.vue";

export default {
    data() {
        return {
            current_view: "",
            current_title: "",
            show_component: false,

            is_home_page: window.location.pathname === "/view" ? true : false,

            all_pages: {
                "voucher": Voucher,
                "voucher_detail": VoucherDetail,
                "my_voucher": MyVoucher,
                "payment_status": PaymentStatus,
            },

            entry_url: this.WEB_URL,

            current_view: "index",
            current_title: "",
            redirect_from: "",

            merchant_id: "",
            voucher_short_id: this.getUrlParam("id") || "",
            my_voucher_record_id: "",
            record_id: "",
            first_entry: false,

            payment_record_id: "",
            // bottom_nav_hidden_view: ["index", "browser_not_supported"],
        };
    },

    inject: ["device_tag", "WEB_URL"],

    mounted() {
        // Export vuejs method to Vanilla JS
        window.app = this;

        // Assign Bootstrap to the window object so it can be used globally
        window.bootstrap = bootstrap;

        if (!this.is_home_page) {
            return false;
        }

        // Show component after assign app and bootstrap
        this.show_component = true;

        // To make sure the init code run after show component
        this.$nextTick(() => {
            this.initMainFunction();
        })
    },

    computed: {
        currentView() {
            return this.all_pages[this.current_view];
        },
    },

    methods: {
        visibility(view) {
            return this.current_view == view;
        },

        // bottomNavVisibility() {
        //     return !this.bottom_nav_hidden_view.includes(this.current_view);
        // },

        initMainFunction() {
            this.LOADER.visibility("show");

            if (ENV_MODE == "PRODUCTION") {
                this.device_tag = device_tag;
            }

            if (this.device_tag.length > 10) {
                this.loadData();
                return true;
            }

            return false;
        },

        loadData() {
            this.redirectToHome();
            this.LOADER.visibility("hide");
            return false;
        },

        redirectToHome() {
            if (this.voucher_short_id) {
                /* if (!this.$refs.index.back_hidden_view.includes(this.current_view)) {
                    this.$refs.index.back_hidden_view.push("voucher_detail");
                } */

                this.redirectToVoucherDetail();
                return true;
            }

            this.redirectToVoucher(true);
            return false;
        },

        generateRecordStatusClass(status) {
            if (status == 1) {
                return "text-bg-primary";
            }

            if (status == 11) {
                return "text-bg-success";
            }

            if (status == 2 || status == 12 || status == 14 || status == 15) {
                return "text-bg-danger";
            }

            if (status == 13) {
                return "text-bg-secondary";
            }

            return "";
        },

        generatePaymentStatusClass(status) {
            if (status == 1 || status == 10) {
                return "text-primary";
            }

            if (status == 11) {
                return "text-secondary";
            }

            if (status == 12) {
                return "text-danger";
            }

            return "";
        },

        generateHistoryStatusLabel(payment_status, status) {
            var final_status = status;

            if (payment_status != "PAID") {
                final_status = payment_status;
            }
            return final_status;
        },

        generateHistoryStatusClass(status) {
            if (status == 1 || status == 10) {
                return "bg-primary";
            }

            if (status == 11) {
                return "bg-warning";
            }

            if (status == 12 || status == 14) {
                return "bg-danger";
            }

            if (status == 13) {
                return "bg-secondary";
            }

            return "";
        },

        updateVoucherView(voucher_id = "") {
            return this.updatePageView(voucher_id).then(response_data => {
                if (!response_data) {
                    return false;
                }

                return true;
            });
        },

        // Deprecated
        retrieveRecordId(masked_id) {
            const index_affix = ["_", "=", "/", "?", "~"];
            let start_index = 0;
            let last_index = 0;

            for (let i = 0; i < index_affix.length; i++) {
                const index = masked_id.indexOf(index_affix[i]);
                if (index !== -1) {
                    if (start_index < last_index) {
                        start_index = index + 1;
                    } else {
                        last_index = index;
                    }
                }
            }

            let record_id_length_and_index = masked_id.substring(start_index, last_index);
            let record_id_length = parseInt(record_id_length_and_index.charAt(0));
            let record_id_index = parseInt(record_id_length_and_index.substring(1));
            let record_id = masked_id.substring(record_id_index, record_id_index + record_id_length);

            return record_id;
        },

        // Deprecated
        maskRecordId(record_id, length = 16) {
            const index_affix = ["_", "=", "/", "?", "~"];
            var record_id_length = record_id.toString().length;
            var random_str = this.randomStr(length - record_id_length - 2, true); // -2 is for store index_char and record_id length

            const index = Math.floor(Math.random() * index_affix.length);
            var random_index_prefix = index_affix[index];
            var random_index_suffix = index_affix[(index + 1 + Math.floor(Math.random() * (index_affix.length - 1))) % index_affix.length];
            var random_index = this.randomInt(1, random_str.length);
            var masked_record_id = random_str.substring(0, random_index) + record_id + random_str.substring(random_index) + random_index_prefix + random_index + record_id_length + random_index_suffix;

            return masked_record_id;
        },

        redirectToGoogleMaps(lat, lng) {
            var url = "https://www.google.com/maps?q=" + lat + "," + lng;
            return window.open(url, '_blank');
        },

        redirectToVoucher(first_entry = false) {
            this.first_entry = first_entry;

            // this.$refs.index.back_hidden_view = this.removeArrayElement(this.$refs.index.back_hidden_view, "voucher_detail")

            this.voucher_short_id = "";
            this.redirect_from = this.current_view;
            this.current_title = "";
            this.current_view = "voucher";
        },

        redirectToVoucherDetail() {
            this.redirect_from = this.current_view;
            this.current_title = "Detail";
            this.current_view = "voucher_detail";
        },

        redirectToMyVoucher() {
            this.redirect_from = this.current_view;
            this.current_title = "My Voucher";
            this.current_view = "my_voucher";
        },

        redirectToPaymentStatus() {
            this.redirect_from = this.current_view;
            this.current_title = "Payment Status";
            this.current_view = "payment_status";
        },

        redirectToSupport() {
            this.redirect_from = this.current_view;
            this.current_title = "Support";
            this.current_view = "support";
        },

        redirectAfterPayment(status) {
            this.voucher_short_id = "";
            this.record_id = "";
            this.my_voucher_record_id = "";
            /* if (status == "success") {
                if (this.payment_record_id) {
                    this.redirectToHistoryDetail();
                }

                if (!this.payment_record_id) {
                    this.redirectToHistory();
                }

                return true;
            } */

            this.redirectToMyVoucher();
            return false;
        }
    },
};
</script>